module.exports = {"522633100":"丙妹镇","522633101":"贯洞镇","522633102":"洛香镇","522633103":"下江镇","522633104":"宰便镇","522633105":"西山镇","522633106":"停洞镇","522633107":"往洞镇","522633108":"庆云镇","522633109":"斗里镇","522633110":"东朗镇","522633111":"加鸠镇","522633200":"高增乡","522633201":"谷坪乡","522633204":"刚边壮族乡","522633205":"加榜乡","522633206":"秀塘壮族乡","522633208":"翠里瑶族壮族乡","522633212":"加勉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522633.json
// module id = 2334
// module chunks = 0